import OlbTooltipDirective from './tooltipDirective';
import OlbTooltip from './tooltip.vue';

export { OlbTooltipDirective };
export default OlbTooltip;
